import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [settings, setSettings] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const s = await api.get("/settings");
        setSettings(s.data);
      } catch {}
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("modav_token", data.access_token);
    setUser(data.user);
    try {
      const s = await api.get("/settings");
      setSettings(s.data);
    } catch {}
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("modav_token");
    setUser(false);
    setSettings(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, settings, login, logout, refreshMe: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
